export default __webpack_public_path__ + "static/media/pic6.2fb1ed05.jpg";